import { render, staticRenderFns } from "./ObjectsList.vue?vue&type=template&id=fbf2cfe8&scoped=true&lang=pug"
import script from "./ObjectsList.vue?vue&type=script&lang=js"
export * from "./ObjectsList.vue?vue&type=script&lang=js"
import style0 from "./ObjectsList.vue?vue&type=style&index=0&id=fbf2cfe8&prod&lang=stylus"
import style1 from "./ObjectsList.vue?vue&type=style&index=1&id=fbf2cfe8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf2cfe8",
  null
  
)

export default component.exports